import { render, staticRenderFns } from "./OAuthConnectionList.vue?vue&type=template&id=097b8fa8&scoped=true&"
import script from "./OAuthConnectionList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OAuthConnectionList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OAuthConnectionList.vue?vue&type=style&index=0&id=097b8fa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097b8fa8",
  null
  
)

export default component.exports